import { render, staticRenderFns } from "./TableAudit.vue?vue&type=template&id=07d8d632"
import script from "./TableAudit.vue?vue&type=script&lang=js"
export * from "./TableAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports